import {useState, useEffect, useRef} from 'react';
import {fetchCaseList} from 'web/redux/actions/CaseActions';
import enumList from 'web/utils/enumList';
import {useNavigate} from 'react-router-dom';
import {
  DataTableComponent,
  batchCheckControls,
} from '../../../components/CommonComponent';
import {
  CASE_PRIORITY_HIGH,
  CASE_PRIORITY_NORMAL,
  FLG_CLOSE,
  FLG_OPEN,
} from 'web/constant';
import $ from 'jquery';
import moment from 'moment';

export const useCase = (dispatch, showMessage, baseComponent) => {
  const navigate = useNavigate();
  const [caseList, setCaseList] = useState([]);
  const tableRef = useRef(null);
  const getCaseList = (casePriority, flgStatus, startTime, endTime) => {
    startTime = moment(startTime).startOf('day').format('YYYYMMDDHHmmss') || ''; // 👉 20250417 00:00:00
    endTime = moment(endTime).endOf('day').format('YYYYMMDDHHmmss') || ''; // 👉 20250417 23:59:5

    if (!tableRef.current) prepareCaseTable([]);
    tableRef.current.processing(true);

    dispatch(
      fetchCaseList({
        casePriority,
        flgStatus,
        startTime,
        endTime,
        batchMachineCheck: true,
      }),
    )
      .then((res) => {
        const statusCode = res.payload.code;
        if (statusCode.isSuccessCode()) {
          const caseListRes = res.payload.result;
          setCaseList(caseListRes);
          prepareCaseTable(caseListRes);
          tableRef.current.processing(false);
        } else {
          showMessage(enumList.messageModalMode.error, res.payload.message);
          console.error('fetchCaseList error', res);
        }
      })
      .catch((err) => {
        console.error('fetchCaseList error', err);
      });
  };

  const prepareCaseTable = (caseList) => {
    // 定義資料內容
    const dataSet = caseList.map((caseItem) => {
      return [
        caseItem.casePriority,
        caseItem.caseNumber,
        caseItem.createTime,
        caseItem.customerName,
        caseItem.description,
        caseItem.employeeName,
        caseItem.handleTime,
        caseItem.flgStatus,
        caseItem.isBatchMachine,
      ];
    });

    // 定義欄位屬性
    const columnConfig = [
      {
        title: '案件等級',
        className: 'dt-center ',
        data: 0,
        render: (data, type, row, meta) => {
          // let enableId = 'eab-elevator-' + meta.row;
          const casePriority =
            data === enumList.casePriority.high
              ? CASE_PRIORITY_HIGH
              : CASE_PRIORITY_NORMAL;
          const labelStyle =
            data === enumList.casePriority.high ? 'status-rush' : '';
          return ` <div class="d-flex justify-content-center align-items-center">
                      <div class="status ${labelStyle}  ">
                        <span>${casePriority}</span> 
                      </div>
                  </div>`;
        },
      },
      {title: '案件編號', className: 'dt-center', data: 1},
      {
        title: '立案時間',
        className: 'dt-center',
        data: 2,
        render: (data) =>
          data ? moment(data).format('YYYY-MM-DD HH:mm:ss') : '',
        type: 'datetime',
      },
      {title: '客戶名稱', className: 'dt-center', data: 3},
      {title: '案件內容', className: 'dt-center text-center', data: 4},
      {
        orderable: false,
        order: null,
        title: '案件狀態',
        data: 7,
        className: 'dt-center',
        render: (data, type, row, meta) => {
          // let enableId = 'eab-elevator-' + meta.row;
          const caseStatus =
            data === enumList.caseFlgStatus.close ? FLG_CLOSE : FLG_OPEN;
          const labelStyle =
            data === enumList.caseFlgStatus.close
              ? 'status-normal'
              : 'status-danger';
          return `<div class="d-flex justify-content-center align-items-center">
                    <div class="status ${labelStyle} mb-1 "> 
                      <span>${caseStatus}</span>
                    </div>
                  </div>`;
        },
      },
      {
        orderable: false,
        order: null,
        title: '是否批量派機',
        data: 8,
        className: 'dt-center text-center ',
        render: (data, type, row, meta) => {
          const text = data ? '批量' : '單機';

          return `
           <div class="d-flex justify-content-center w-100  "> 
            <div class="status">
              <span>${text}</span> 
            </div>
          </div>`;
        },
      },
      {
        orderable: false,
        order: null,
        data: null,
        className: 'dt-right',
        render: (data, type, row, meta) => {
          const editId = 'edit-case-' + meta.row;
          // let deleId = 'dele-department-' + meta.row;
          // data[0] = departmentCode
          // const departmentCode = data[0];

          const updateButton = baseComponent.checkPermission(
            enumList.moduleEnums.case,
            enumList.accessModeEnums.update,
          )
            ? `<button type="button" class="btn btn-sm btn-link" id="${editId}">
                    <svg class="btn__icon btn__icon--sm me-1" aria-hidden="true">
                        <use href="#ico-edit"></use>
                    </svg>
                    修改
                </button>`
            : '';
          // let deleteButton = baseComponent.checkPermission(enumList.moduleEnums.case, enumList.accessModeEnums.delete)
          //   ? `<button type="button" class="btn btn-sm btn-link" id="${deleId}">
          //           刪除
          //       </button>`
          //   : '';
          return `
                <div class="btn-group" role="group" aria-label="">
                    ${updateButton}
                </div>`;
        },
      },
    ];

    // 定義排序設定
    const orderConfig = {
      idx: 1,
      dir: 'asc',
    };

    // 定義固定欄位設定
    const fixedColumnsConfig = {
      start: 1,
    };

    // 先清除datatable
    if ($.fn.DataTable.isDataTable('#datatable__caseList')) {
      $('#datatable__caseList').DataTable().destroy();
    }

    // 重新繪製datatable
    tableRef.current = DataTableComponent(
      '#datatable__caseList',
      dataSet,
      columnConfig,
      orderConfig,
      fixedColumnsConfig,
      true,
      true,
    );
    setCaseList(caseList);
    batchCheckControls();
  };

  const onNewCase = () => {
    navigate('/module/cases-apply');
  };

  const handleSearch = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const searchForm = new FormData(e.target);
    const casePriority = searchForm.get('searchCasePriority');
    const caseFlgStatus = searchForm.get('searchFlgStatus');
    const startTime = searchForm.get('searchStartDate');
    const endTime = searchForm.get('searchEndDate');
    getCaseList(casePriority, caseFlgStatus, startTime, endTime);
  };

  return {caseList, getCaseList, onNewCase, handleSearch};
};
